<template>
	<div @click="enterMconet($event)" :class="['resizable',{hover:itemMdata.parentStyle.active}]" :style="parentStyle">
		<div :id="itemMdata.allId" :class="['hove_con',itemMdata.emitStr,itemMdata.tName]" :style="{width:itemMdata.fullScreen?'100%':itemMdata.parentStyle.width+'px',height:itemMdata.parentStyle.height+'px'}">		
			<div :itemMdata="itemMdata" ref="child" :is="itemMdata.tName"></div>
		</div>
	</div>
</template>
<script>
	let ov = {};
	//import api from '@/api/$ajax.js'
	let mName = ['mFont', 'mImage', 'mButton', 'graphic', 'mNewDes', 'columnPicture', 'mCaseDes', 'mPhotoDes', 'multiCarousel', 'circleRrea', 'articleScrap', 'productNav', 'newlyShop','areaVideo', 'productShow', 'productDes', 'productSearch', 'photoMoreCard', 'areaFile', 'areaMap', 'areaIndexFavorite', 'areaLocation', 'areaMap', 'videoNav', 'sidebar', 'moduleAreaNav', 'footerNav', 'memberLogin', 'msgSubmit', 'siteForm', 'serviceOnline', 'siteQrCode', 'zhaopin', 'zhaopinDetail', 'mltilingual', 'areaFileNav', 'areaCode', 'sitemap', 'singlePage', 'areaDate', 'areaFlv', 'friendLink', 'searchResults'];

	for(let m = 0; mName.length > m; m++) {
		ov[mName[m]] = () =>
			import('./m/' + mName[m] + '.vue');
	}
	export default {
		name: 'mConet',
		props: ['itemMdata', "itemInner"],
		components: ov,
		created() {
			let ts = this;
			ts.parentStyle.top = ts.itemMdata.parentStyle.top + "px";
			ts.parentStyle.left = ts.itemMdata.parentStyle.left + "px";
			ts.parentStyle.position = "absolute";
			ts.parentStyle.width = ts.itemMdata.parentStyle.width + "px";
			ts.parentStyle.height = ts.itemMdata.parentStyle.height + "px";
			ts.parentStyle.zIndex = ts.itemMdata.parentStyle.zIndex;
			if(ts.itemMdata.tName == "mImage" || ts.itemMdata.tName == "mFont" || ts.itemMdata.tName == "mButton" || ts.itemMdata.tName == "columnPicture") {
				ts.editDial.isSave = true;
			}
		},
		methods: {
			enterMconet(e) {
				let ts = this;
				e.preventDefault();
				e.stopPropagation();
				ts.itemMdata.parentStyle.active = true;
			},
			leaveMconet() {
				let ts = this;
				ts.itemMdata.parentStyle.active = false;
			},
			manageMode(i) {
				let ts = this;
				ts.editDial.isEdit = true;
				if(i.tName == "mFont") {
					ts.$refs.child.editorFun();
				} else {
					ts.$emit('isFuncur', i, ts.editDial);
				}

			}
		},
		mounted() {
			let ts = this;
			if(ts.itemMdata.emitStr) {
				setTimeout(function(){
					hoverAction.initScroll(ts.itemMdata.allId, ts.itemMdata.emitStr);
				},400);
				
			}
		},
		data() {
			return {
				title: "模块容器",
				param: {
					id: this.$route.params.id,
					param: this.$route.params.param,
					company_id: this.$route.query.company_id,
					token: this.$route.query.token,
					type: this.$route.query.type,
					lang: this.$route.query.lang,
					domain_url: this.$route.query.domain_url,
					mobile_version_id: this.$route.query.mobile_version_id,
					pc_version_id: this.$route.query.pc_version_id
				},
				editDial: {
					editDialWidth: "650px",
					editDialHeight: "650px",
					isSave: false,
					isEdit: false,
					rTitle: '管理模块数据',
					editDialzIndex: 1000
				},
				active: false,
				parentStyle: {}
			}
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	.hove_con .edit_con {
		top: -10px !important;
		padding: 3px;
		height: 23px;
		min-width: auto !important;
	}
	
	.pc_con .resizable.hover {
		z-index: 33333 !important;
	}
	
	.pc_con .hover p.edit_con {
		display: inline-block;
	}
	
	.pc_con .hove_con .edit_con span {
		margin: 0 4px;
	}
</style>


// WEBPACK FOOTER //
// src/components/t1/prev/mConet.vue